
/* injects from baggage-loader */

import { ShapeConst } from '_appRoot/index.const';

const shapeSmallWidth = 24;
const shapeSmallHeight = 25;

const shapeBigWidth = 38;
const shapeBigHeight = 38;

export const shapes = [
	{ 
		src: require('_images/blue/shapes/circle-yellow-1.png') , 
		width: shapeSmallWidth, 
		height: shapeSmallHeight, 
		type: ShapeConst.types.circle, 
		color: ShapeConst.colors.yellow,
		size: ShapeConst.sizes.small
	},
	{ 
		src: require('_images/blue/shapes/triangle-yellow-1.png') , 
		width: shapeSmallWidth, 
		height: shapeSmallHeight, 
		type: ShapeConst.types.triangle, 
		color: ShapeConst.colors.yellow  ,
		size: ShapeConst.sizes.small
	},
	{ 
		src: require('_images/blue/shapes/rect-yellow-1.png') , 
		width: shapeSmallWidth, 
		height: shapeSmallHeight, 
		type: ShapeConst.types.square, 
		color: ShapeConst.colors.yellow  ,
		size: ShapeConst.sizes.small
	},
	{ 
		src: require('_images/blue/shapes/rect-yellow-b-1.png') , 
		width: 25, 
		height: 19, 
		type: ShapeConst.types.rect, 
		color: ShapeConst.colors.yellow  ,
		size: ShapeConst.sizes.small
	},

	{ 
		src: require('_images/blue/shapes/circle-red-1.png') , 
		width: shapeSmallWidth, 
		height: shapeSmallHeight, 
		type: ShapeConst.types.circle, 
		color: ShapeConst.colors.red ,
		size: ShapeConst.sizes.small
	},
	{ 
		src: require('_images/blue/shapes/triangle-red-1.png') , 
		width: shapeSmallWidth, 
		height: shapeSmallHeight, 
		type: ShapeConst.types.triangle, 
		color: ShapeConst.colors.red  ,
		size: ShapeConst.sizes.small
	},
	{ 
		src: require('_images/blue/shapes/rect-red-1.png') , 
		width: shapeSmallWidth, 
		height: shapeSmallHeight, 
		type: ShapeConst.types.square, 
		color: ShapeConst.colors.red  ,
		size: ShapeConst.sizes.small
	},
	{ 
		src: require('_images/blue/shapes/rect-red-b-1.png') , 
		width: 25, 
		height: 19, 
		type: ShapeConst.types.rect, 
		color: ShapeConst.colors.red  ,
		size: ShapeConst.sizes.small
	},

	{ 
		src: require('_images/blue/shapes/circle-blue-1.png') , 
		width: shapeSmallWidth, 
		height: shapeSmallHeight, 
		type: ShapeConst.types.circle, 
		color: ShapeConst.colors.blue ,
		size: ShapeConst.sizes.small
	},
	{ 
		src: require('_images/blue/shapes/triangle-blue-1.png') , 
		width: shapeSmallWidth, 
		height: shapeSmallHeight, 
		type: ShapeConst.types.triangle,
		color: ShapeConst.colors.blue  ,
		size: ShapeConst.sizes.small
	},
	{ 
		src: require('_images/blue/shapes/rect-blue-1.png') , 
		width: shapeSmallWidth, 
		height: shapeSmallHeight, 
		type: ShapeConst.types.square,
		color: ShapeConst.colors.blue  ,
		size: ShapeConst.sizes.small
	},
	{ 
		src: require('_images/blue/shapes/rect-blue-b-1.png')  , 
		width:25, 
		height: 19 , 
		type: ShapeConst.types.rect,
		color: ShapeConst.colors.blue,
		size: ShapeConst.sizes.small
	},


	{ 
		src: require('_images/blue/shapes/circle-yellow-2.png'), 
		width: shapeBigWidth, 
		height: shapeBigHeight, 
		type: ShapeConst.types.circle, 
		color: ShapeConst.colors.yellow,
		size: ShapeConst.sizes.big
	},
	{ 
		src: require('_images/blue/shapes/triangle-yellow-2.png'), 
		width: shapeBigWidth, 
		height: shapeBigHeight, 
		type: ShapeConst.types.triangle, 
		color: ShapeConst.colors.yellow,
		size: ShapeConst.sizes.big
	},
	{ 
		src: require('_images/blue/shapes/rect-yellow-2.png'), 
		width: shapeBigWidth, 
		height: shapeBigHeight, 
		type: ShapeConst.types.square, 
		color: ShapeConst.colors.yellow,
		size: ShapeConst.sizes.big
	},
	{ 
		src: require('_images/blue/shapes/rect-yellow-b-2.png'), 
		width: 39, 
		height: 28, 
		type: ShapeConst.types.rect, 
		color: ShapeConst.colors.yellow,
		size: ShapeConst.sizes.big
	},

	{ 
		src: require('_images/blue/shapes/circle-red-2.png'), 
		width: shapeBigWidth, 
		height: shapeBigHeight, 
		type: ShapeConst.types.circle,
		color: ShapeConst.colors.red,
		size: ShapeConst.sizes.big
	},
	{ 
		src: require('_images/blue/shapes/triangle-red-2.png'), 
		width: shapeBigWidth, 
		height: shapeBigHeight, 
		type: ShapeConst.types.triangle,
		color: ShapeConst.colors.red,
		size: ShapeConst.sizes.big
	},
	{ 
		src: require('_images/blue/shapes/rect-red-2.png'), 
		width: shapeBigWidth, 
		height: shapeBigHeight, 
		type: ShapeConst.types.square,
		color: ShapeConst.colors.red,
		size: ShapeConst.sizes.big
	},
	{ 
		src: require('_images/blue/shapes/rect-red-b-2.png'), 
		width: 39, 
		height: 28, 
		type: ShapeConst.types.rect,
		color: ShapeConst.colors.red,
		size: ShapeConst.sizes.big
	},

	{ 
		src: require('_images/blue/shapes/circle-blue-2.png'), 
		width: shapeBigWidth, 
		height: shapeBigHeight, 
		type: ShapeConst.types.circle,
		color: ShapeConst.colors.blue,
		size: ShapeConst.sizes.big
	},
	{ 
		src: require('_images/blue/shapes/triangle-blue-2.png'), 
		width: shapeBigWidth, 
		height: shapeBigHeight, 
		type: ShapeConst.types.triangle,
		color: ShapeConst.colors.blue,
		size: ShapeConst.sizes.big
	},
	{ 
		src: require('_images/blue/shapes/rect-blue-2.png'), 
		width: shapeBigWidth, 
		height: shapeBigHeight, 
		type: ShapeConst.types.square,
		color: ShapeConst.colors.blue,
		size: ShapeConst.sizes.big
	},
	{ 
		src: require('_images/blue/shapes/rect-blue-b-2.png') , 
		width:39, 
		height: 28, 
		type: ShapeConst.types.rect,
		color: ShapeConst.colors.blue,
		size: ShapeConst.sizes.big
	},

]


// WEBPACK FOOTER //
// ./src/app/components/ui/draw-game/draw-game.const.js